import React from 'react';
import { Typography, Switch } from 'antd';
import SettingsRowShell from './SettingsRowShell';

const { Text } = Typography;

interface SettingsToggleRowProps {
  title: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  loading?: boolean;
}

/** "Title + description on the left, Switch on the right" row, same hover-highlight shell as SettingsRow. */
const SettingsToggleRow: React.FC<SettingsToggleRowProps> = ({ title, description, checked, onChange, loading }) => (
  <SettingsRowShell
    left={
      <div>
        <Text strong style={{ fontSize: 15 }}>
          {title}
        </Text>
        {description && (
          <div style={{ marginTop: 2 }}>
            <Text type="secondary">{description}</Text>
          </div>
        )}
      </div>
    }
    right={<Switch checked={checked} onChange={onChange} loading={loading} />}
  />
);

export default SettingsToggleRow;
